<template>
  <div>
    <div v-if="!loading && companies.length > 1 && !demoMode" class="pt-2">
      <div class="clear">
        <v-container grid-list-md class="pa-0" fluid>
          <v-layout row wrap>
            <v-flex md3 xs12>
              <v-select
                v-if="!loading && companies.length > 1"
                :items="filteredCompanies"
                :item-color="companyPrimaryColor"
                :background-color="$vuetify.theme.themes[theme].menu"       
                item-text="name"
                item-value="id"
                v-on:input="loadActiveCompData()"
                v-model="activeComp"
                no-data-text="Geen bedrijven gevonden."
                label="Selecteer bedrijf"
                outlined
                dense>
                <template v-slot:prepend-item>
                  <v-list-item>
                    <v-list-item-content  class="pt-0" >
                      <v-text-field
                        :color="companyPrimaryColor"
                        placeholder="Zoeken"
                        prepend-inner-icon="search"
                        clearable
                        v-model="searchCompanies"
                        hide-details
                        dense
                      ></v-text-field>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider></v-divider>
                  <div v-if="searchCompanies && searchCompanies.length > 0" style="padding: 4px 17px 3px 17px; background-color:rgba(0,0,0, 0.02); color: rgba(0, 0, 0, 0.6); text-align: center; font-size: 12px">{{ filteredCompanies.length }} van {{ companies.length }} bedrijven</div>
                  <v-divider v-if="searchCompanies && searchCompanies.length > 0"></v-divider>
                </template>
              </v-select>
            </v-flex>
          </v-layout>
        </v-container>
      </div>
    </div>

    <div v-if="loading" class="blackbox-loader"></div>
  
    <div v-if="loading == false" class="special-content-box">
      <tabs :options="{ useUrlFragment: false }">

        <tab name="Vestigingen" v-if="userRole == 'superadmin' || userRole == 'admin'">
          <div v-if="loading == false">
            <div class="tab-inner-wrapper padding">
              <div class="tab-content">
                <v-container grid-list-md class="pa-0" fluid>
                  <v-layout row wrap>
                    <v-flex md6 xs12>
                      <h1 class="tab-title">Vestigingen</h1>
                    </v-flex>

                    <v-flex md6 xs12>
                      <v-row v-if="branches.length > 0">
                        <v-text-field
                          class="px-2"
                          v-model="search"
                          :color="companyPrimaryColor"
                          background-color="background"
                          name="searchfield"
                          placeholder="Zoeken"
                          outlined
                          hide-details                                                     
                          prepend-inner-icon="search"
                          autocomplete="disabled"
                          clearable
                          single-line>
                        </v-text-field>
                        <v-btn class="px-2" fab dark :color="companyPrimaryColor" @click="newBranchDialog = true">
                          <v-icon darken>add</v-icon>
                        </v-btn>
                        <v-btn class="px-2" fab darken :color="companySecondaryColor" v-if="selected.length > 0" @click="deleteBranch()">
                          <v-icon darken>delete</v-icon>
                        </v-btn>
                      </v-row>
                    </v-flex>

                  </v-layout>
                </v-container>
  
                <div class="first-item-button text-center" v-if="branches.length == 0">
                  <p>Er zijn nog geen vestingen aangemaakt.</p>
                  <v-btn  :color="companySecondaryColor" dark @click="newBranchDialog = true">
                    Voeg een vestiging toe
                  </v-btn>
                </div>
              </div>
            </div>
          </div>

          <div v-if="branches.length > 0">
            <div v-if="branches.length === 0" style="padding: 50px; text-align: center;">
              Geen resultaten gevonden voor <strong>"{{ search }}"</strong>.
            </div>
            <div v-else>
              <v-data-table
                :headers="headersBranches"
                :items="branches"
                :search="search"
                :itemsPerPage.sync="branchesPages"
                hide-default-footer
                :no-results-text="`Geen resultaten gevonden voor: ${search}`"
              >
                <template v-slot:item="{ item }">
                  <tr>
                    <td>{{ item.branchName }}</td>
                    <td>{{ item.address }} {{ item.number }}<span v-if="item.city && item.address">,</span> {{ item.city }}</td>
                    <td>{{ item.province }}</td>
                    <td>
                      <v-btn style="float: right;" icon class="mx-0" @click="editBranch(item)">
                        <v-icon small :color="$vuetify.theme.themes[theme].text">edit</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </template>
              </v-data-table>    
            </div>          
          </div>
            
        </tab>

        <tab name="API koppelingen" v-if="userRole == 'superadmin' || userRole == 'admin'">
          <div v-if="loading == false" class="tab-inner-wrapper padding">
            <div class="tab-content">
              <v-container grid-list-md class="pa-0" fluid>
                <v-layout row wrap>
                  <v-flex md6 xs12>
                    <h1 class="tab-title">API koppelingen</h1>
                  </v-flex>
                  <v-flex md6 xs12>
                    <div style="display: inline-block; float: right;">
                      <v-btn rounded :color="companySecondaryColor" class="modal-button-next" :dark="apiSettingsChanged" :disabled="!apiSettingsChanged" :depressed="!apiSettingsChanged" @click="updateCompanyApi()">Wijzigingen opslaan<v-icon right dark>chevron_right</v-icon></v-btn>
                    </div>
                  </v-flex>
                </v-layout>
              </v-container>

              <div class="api-content-wrapper">
                <v-form>
                  <div class="api-switch-wrapper">
                    <v-switch
                      label="Koppeling met software of website"
                      v-model="activeCompData.apiActive"
                      :color="companyPrimaryColor"
                    ></v-switch>
                  </div>

                  <div v-if="activeCompData.apiActive == true" class="api-select-wrapper">
                    <h3>Selecteer API's</h3>
                    <div v-for="apiItem in availableApiItems" :key="apiItem.id"  style="padding: 0 20px;">
                      <v-checkbox :label="`${apiItem.name}`" :color="companyPrimaryColor" v-model="activeCompData.apiItems[apiItem.id]"></v-checkbox>
                    </div>
                  </div>

                  <v-container id="custom-container" fluid grid-list-md>
                    <v-layout row wrap>
                      <v-flex  v-if="activeCompData.apiItems.salonhub == true" d-flex xs6>
                        <v-card outlined min-width="100%" :color="$vuetify.theme.themes[theme].menuhover">
                          <v-card-text>

                            <h3>Salonhub API Settings</h3>
                            <div class="api-salonhub-check-success" v-if="salonhubApiCheck == 'success'">
                              <v-icon medium color="light-green">check_circle</v-icon>
                            </div>
                            <div class="api-salonhub-check-warning" v-if="salonhubApiCheck == 'warning'">
                              <v-icon medium color="amber">warning</v-icon>
                            </div>

                            <div class="api-salonhub-logo"></div>
                            <div class="api-textfields">
                              <v-text-field
                                label="klant"
                                v-model="activeCompData.salonhubApiSettings.customer"
                                outlined
                                background-color="menu"
                                >
                              </v-text-field>

                              <v-text-field
                                label="Gebruikersnaam"
                                v-model="activeCompData.salonhubApiSettings.username"
                                outlined
                                background-color="menu"
                                >
                              </v-text-field>

                              <v-text-field
                                label="Wachtwoord"
                                outlined
                                background-color="menu"
                                :type="showPassword ? 'text' : 'password'"
                                @click:append="showPassword = !showPassword"
                                :append-icon="showPassword ? 'visibility_off' : 'visibility'"
                                v-model="activeCompData.salonhubApiSettings.password"
                                >
                              </v-text-field>
                              <div class="hogans-alerts">
                                <v-alert
                                  v-if="salonhubApiFeedback"
                                  v-model="salonhubApiAlert"
                                  type="warning"
                                  transition="scale-transition"
                                  dismissible
                                  >
                                  {{ salonhubApiFeedback }}
                                </v-alert>
                                <v-alert
                                  v-if="salonhubApiSuccess"
                                  v-model="salonhubApiAlertSuccess"
                                  type="success"
                                  transition="scale-transition"
                                  dismissible
                                  >
                                  {{ salonhubApiSuccess }}
                                </v-alert>
                              </div>
                              <v-btn :color="companySecondaryColor" dark block @click="createMD5()">Connect API</v-btn>
                            </div>
                          </v-card-text>
                        </v-card>
                      </v-flex>

                      <v-flex v-if="activeCompData.apiItems.drupal == true" d-flex xs6>
                        <v-card outlined min-width="100%" :color="$vuetify.theme.themes[theme].menuhover">
                          <h3>Drupal API Settings</h3>
                          <div class="api-drupal-logo"></div>
                          <p>Instellingen voor Drupal moeten ingesteld worden bij Vestigingen.</p>

                          <div class="drupal-api-settings-update">
                            <div class="drupal-api-branch-update" v-for="(branch, index) in branches" :key="index">
                              <div class="hogans-alerts">
                                <v-alert
                                  v-if="!branch.drupalApiSettings.url"
                                  :value="true"
                                  type="warning"
                                  transition="scale-transition"
                                  class="mt-2"
                                  >
                                  {{ branch.branchName}} bevat <b>geen</b> API-url
                                </v-alert>
                                <v-alert
                                  v-if="branch.drupalApiSettings.url"
                                  :value="true"
                                  type="success"
                                  transition="scale-transition"
                                  class="mt-2"
                                  >
                                  {{ branch.branchName}} bevat API-url
                                </v-alert>
                              </div>
                            </div>
                          </div>
                        </v-card>

                      </v-flex>

                      <v-flex v-if="activeCompData.apiItems.dyflexis == true" d-flex xs6>
                        <v-card outlined min-width="100%" class="pa-4" :color="$vuetify.theme.themes[theme].menuhover">
                          <h3>Dyflexis API Settings</h3>
                          <div class="api-dyflexis-logo"></div>

                          <v-text-field
                            outlined
                            background-color="menu"
                            label="API-key"
                            :type="showDyflexisApi ? 'text' : 'password'"
                            @click:append="showDyflexisApi= !showDyflexisApi"
                            :append-icon="showDyflexisApi ? 'visibility_off' : 'visibility'"
                            v-model="activeCompData.dyflexisSettings.api"
                            >
                          </v-text-field>
                          

   
                        </v-card>

                      </v-flex>
                    </v-layout>
                  </v-container>

                </v-form>
              </div>
            </div>
          </div>
        </tab>

        <tab name="Social" v-if="userRole == 'superadmin' || userRole == 'admin' || userRole == 'manager'">
          <div v-if="loading == false" class="tab-inner-wrapper padding">
            <div class="tab-content">
              <v-container grid-list-md class="pa-0" fluid>
                <v-layout row wrap>
                  <v-flex md6 xs12>
                    <h1 class="tab-title">Social koppelingen</h1>
                    <p>Actieve social koppelingen worden weergeven onder verzonden e-mail.</p>
                  </v-flex>
                  <v-flex md6 xs12>
                    <div style="display: inline-block; float: right;">
                      <v-btn rounded :color="companySecondaryColor" class="modal-button-next" :dark="socialChanged" :disabled="!socialChanged" :depressed="!socialChanged" @click="updateCompanySocial()">Wijzigingen opslaan<v-icon right dark>chevron_right</v-icon></v-btn>
                    </div>
                  </v-flex>
                </v-layout>
              </v-container>

              <v-card outlined min-width="100%" class="my-2 pa-4" :color="$vuetify.theme.themes[theme].menuhover">
                <div class="social-header clear">
                  <div class="social-header-icon facebook"></div>
                  <h3>Facebook</h3>
                </div>

                <v-switch
                  label="Actief"
                  :color="companyPrimaryColor"
                  v-model="activeCompData.social.facebook"
                  hide-details
                  class="pb-2"
                ></v-switch>

                <v-text-field
                  v-if="activeCompData.social.facebook == true"
                  label="Link naar Facebookpagina"
                  v-model="activeCompData.social.facebookUrl"
                  hint="Voer hier de volledige URL in: https://www.facebook.com/bedrijf/"
                  persistent-hint
                ></v-text-field>
              </v-card>

              <v-card outlined min-width="100%" class="my-2 pa-4" :color="$vuetify.theme.themes[theme].menuhover">
                <div class="social-header clear">
                  <div class="social-header-icon instagram"></div>
                  <h3>Instagram</h3>
                </div>

                <v-switch
                  label="Actief"
                  :color="companyPrimaryColor"
                  v-model="activeCompData.social.instagram"
                  hide-details
                  class="pb-2"
                ></v-switch>
    
                <v-text-field
                  v-if="activeCompData.social.instagram == true"
                  label="Link naar Instagrampagina"
                  v-model="activeCompData.social.instagramUrl"
                  hint="Voer hier de volledige URL in: https://www.instgram.com/bedrijf/"
                  persistent-hint
                ></v-text-field>
              </v-card>

              <v-card outlined min-width="100%" class="my-2 pa-4" :color="$vuetify.theme.themes[theme].menuhover">
                <div class="social-header clear">
                  <div class="social-header-icon twitter"></div>
                  <h3>Twitter</h3>
                </div>

                <v-switch
                  label="Actief"
                  :color="companyPrimaryColor"
                  v-model="activeCompData.social.twitter"
                  hide-details
                  class="pb-2"
                ></v-switch>

                <v-text-field
                  v-if="activeCompData.social.twitter == true"
                  label="Link naar Twitterpagina"
                  v-model="activeCompData.social.twitterUrl"
                  hint="Voer hier de volledige URL in: https://www.twitter.com/account/"
                  persistent-hint
                ></v-text-field>
              </v-card>

              <v-card outlined min-width="100%" class="my-2 pa-4" :color="$vuetify.theme.themes[theme].menuhover">
                <div class="social-header clear">
                  <div class="social-header-icon pinterest"></div>
                  <h3>Pinterest</h3>
                </div>

                <v-switch
                  label="Actief"
                  :color="companyPrimaryColor"
                  v-model="activeCompData.social.pinterest"
                  hide-details
                  class="pb-2"
                ></v-switch>
              

                <v-text-field
                  v-if="activeCompData.social.pinterest == true"
                  label="Link naar Pinterestpagina"
                  v-model="activeCompData.social.pinterestUrl"
                  hint="Voer hier de volledige URL in: https://www.pinterest.com/bedrijf/"
                  persistent-hint
                ></v-text-field>
              </v-card>

              <v-card outlined min-width="100%" class="my-2 pa-4" :color="$vuetify.theme.themes[theme].menuhover">
                <div class="social-header clear">
                  <div class="social-header-icon googleplus"></div>
                  <h3>Google +</h3>
                </div>
            
                <v-switch
                  label="Actief"
                  :color="companyPrimaryColor"
                  v-model="activeCompData.social.googleplus"
                  hide-details
                  class="pb-2"
                ></v-switch>
        
                <v-text-field
                  v-if="activeCompData.social.googleplus == true"
                  label="Link naar Pinterestpagina"
                  v-model="activeCompData.social.googleplusUrl"
                  hint="Voer hier de volledige URL in: https://plus.google.com/bedrijf/"
                  persistent-hint
                ></v-text-field>
              </v-card>

            </div>
          </div>
        </tab>

        <tab name="Gebruikers" v-if="userRole == 'superadmin' || userRole == 'admin' || userRole == 'manager'">
          <div v-if="loading == false" >
            <div  class="tab-inner-wrapper padding">
              <div class="tab-content">
                <v-container grid-list-md class="pa-0" fluid>
                  <v-layout row wrap>
                    <v-flex md6 xs12>
                      <h1 class="tab-title">Gebruikers</h1>
                    </v-flex>

                    <v-flex md6 xs12>
                      <v-row v-if="employeeUsers.length > 0">
                        <v-text-field 
                          class="px-2"
                          v-model="searchUsers"
                          :color="companyPrimaryColor"
                          background-color="background"
                          name="searchfield"
                          placeholder="Zoeken"
                          outlined
                          hide-details                                                     
                          prepend-inner-icon="search"
                          autocomplete="disabled"
                          clearable
                          single-line>
                        </v-text-field>
                        <v-btn class="px-2" fab dark :color="companyPrimaryColor" @click="newUserDialog = true">
                          <v-icon darken>add</v-icon>
                        </v-btn>
                      </v-row>
                    </v-flex>
                  </v-layout>
                </v-container>
              </div>
            </div>

          
            <div class="first-item-button text-center" v-if="employeeUsers.length == 0">
              <p>Er zijn nog geen gebruikers aangemaakt.</p>
              <v-btn  :color="companySecondaryColor" dark @click="newUserDialog = true">
                Voeg een gebruiker toe
              </v-btn>
            </div>

            <div v-if="employeeUsers.length > 0">
              <v-data-table
                :headers="headerUsers"
                :items="employeeUsers"
                :itemsPerPage.sync="userPages"
                :expand.sync="expandedEmployees"
                single-expand
                show-expand
                hide-default-footer
                :search="searchUsers"
                :no-results-text="`Geen resultaten gevonden voor: ${searchUsers}`"
                >
                <template v-slot:item="{item, isExpanded, expand}">
                  <tr>
                    <td>
                      <v-icon small :color="activeColor(item.active)">stop</v-icon>
                    </td> 
                    <td>{{ item.firstName}} {{ item.lastName }}</td>
                    <td>
                      <span v-for="(role, index) in userRoles" :key="index">
                        <span v-if="item.userRole == role.id">{{role.name}}</span>
                      </span>
                    <td>
                      <ul style="padding: 0">
                        <li style="display: block; padding: 2px; margin: 0" v-for="(branch, index) in item.branches" :key="index">
                            <span v-for="(companyBranch, index) in branches" :key="index">
                              <span v-if="companyBranch.id == branch">&#8226; {{ companyBranch.branchName }}</span>
                            </span>
                        </li>
                      </ul>
                    <td>{{ item.email }}</td>
                    <td>
                      <v-btn style="float: right;" icon class="mx-0" @click="editEmployeeUser(item)">
                        <v-icon small :color="$vuetify.theme.themes[theme].text">edit</v-icon>
                      </v-btn>
                    </td>
                    <td>
                      <span v-if="item.userRole != 'admin'">
                        <v-btn icon @click="expand(true)" v-if="!isExpanded"><v-icon :color="$vuetify.theme.themes[theme].text" dark>expand_more</v-icon></v-btn>
                        <v-btn icon @click="expand(false)" v-if="isExpanded"><v-icon :color="$vuetify.theme.themes[theme].text" dark>expand_less</v-icon></v-btn>
                      </span>
                    </td>
                  </tr>
                </template>
                <template v-slot:expanded-item="{ headers, item }">
                  <td :colspan="headers.length" style="padding: 0;">
                    <v-card  flat :style="{backgroundColor: $vuetify.theme.themes[theme].menuhover, borderColor: $vuetify.theme.themes[theme].menuborder}" style="border-bottom: 1px solid">
                      <v-card-text>
                        <h4>Bevoegdheden</h4>
                        <div class="user-permissions-table">
                          <span v-if="companyJourney">
                            <p>Reviews</p>
                            <ul>
                              <li>
                                <v-icon v-if="item.userPermissions.journeyViewJourney" small color="success">check_circle</v-icon>
                                <v-icon v-else small color="error">cancel</v-icon>
                                Journey en vragen bekijken
                              </li>
                              <li>
                                <v-icon v-if="item.userPermissions.journeyEditQuestion" small color="success">check_circle</v-icon>
                                <v-icon v-else small color="error">cancel</v-icon>
                                Stages en vragen maken/bewerken
                              </li>
                              <li>
                                <v-icon v-if="item.userPermissions.journeyEditJourney" x-small color="success">check_circle</v-icon>
                                <v-icon v-else small color="error">cancel</v-icon>
                                Journeys en vragen maken/bewerken
                              </li>                          
                            </ul>
                          </span>
                          
                        
                          <span v-if="companyNarrowcasting == true">
                            <p>Relevant Casting</p>
                            <ul>
                              <li>
                                <v-icon v-if="item.userPermissions.castingUploadContent" x-small color="success">check_circle</v-icon>
                                <v-icon v-else small color="error">cancel</v-icon>
                                Content uploaden
                              </li>
                              <li>
                                <v-icon v-if="item.userPermissions.castingEditPlaylist" x-small color="success">check_circle</v-icon>
                                <v-icon v-else small color="error">cancel</v-icon>
                                Afspeellijst bewerken
                              </li>
                            </ul>
                          </span>
                        </div>
                      </v-card-text>
                    </v-card>
                  </td>
                </template>
              </v-data-table>
            </div>
        
          </div>
        
        </tab>

      </tabs>
    </div>

    <!-- / New Branch Dialog \ -->
    <v-dialog v-model="newBranchDialog" scrollable max-width="600px">
      <add-branch-form :activeCompData="activeCompData"  @newBranchDialogChange="newBranchDialog = $event" @updateData="loadBranches()"></add-branch-form>
    </v-dialog>
    <!-- \ New Branch Dialog / -->

    <!-- / Edit Branch Dialog \ -->
    <v-dialog v-model="editBranchDialog" scrollable max-width="600px">
        <edit-branch-form :activeCompData="activeCompData" :selectedBranch="editBranchInfo" :selectedBranchOriginal="editBranchInfoOriginal" @editBranchDialogChange="editBranchDialog = $event" @updateData="loadBranches()"></edit-branch-form>
    </v-dialog>
    <!-- \ Edit Branch Dialog / -->

    <!-- / New User Dialog \ -->
    <v-dialog v-model="newUserDialog" max-width="600px">
      <add-user-form :formType="'company'" :branches="branches" :activeCompData="activeCompData" :showDialog="newUserDialog" :companies="companies" @newUserDialogChange="newUserDialog = $event" @updateData="loadEmployeeUsers()"></add-user-form>
    </v-dialog>
    <!-- \ New User Dialog / -->

    <!-- / Edit User Dialog \ -->
    <v-dialog v-model="editUserDialog" max-width="600px">
      <edit-user-form :formType="'company'" :branches="branches" :activeCompData="activeCompData"  :showEditDialog="editUserDialog" :companies="companies" :userFormInfoOriginal="editUserInfoOriginal" :userFormInfo="editUserInfo" @userEditDialogChange="editUserDialog = $event" @updateData="loadEmployeeUsers()"></edit-user-form>
    </v-dialog>
    <!-- \ Edit User Dialog / -->

  </div>
</template>


<script>
import { bus } from "../main";
import db from "../firebase/init";
import axios from "axios";
import AddBranchForm from "../components/modals/AddBranchForm.vue";
import EditBranchForm from "../components/modals/EditBranchForm.vue";
import AddUserForm from "../components/modals/AddUserForm.vue";
import EditUserForm from "../components/modals/EditUserForm.vue";
import platform from 'platform'; 

export default {
  components: {
    "add-branch-form": AddBranchForm,
    "add-user-form": AddUserForm,
    "edit-branch-form": EditBranchForm,
    "edit-user-form": EditUserForm
  },
  name: "Settings",

  data: () => ({

    expandedEmployees: [],
    loading: true,
    feedback: null,  
    paginationBranches: {
      sortBy: "branchName",
      rowsPerPage: 100,
      descending: false
    },
    paginationUsers: {
      sortBy: "firstName",
      rowsPerPage: 100,
      descending: false
    },
    search: "",
    activeCompData: {
      apiItems: {
        drupal: false,
        salonhub: false
      },
      social: {
        facebook: false,
        facebookUrl: null
      }
    },
    searchCompanies: "",
    searchUsers: "",
    editUserInfo: {
      userPermissions: {}
    },
    branchesPages: -1,
    userPages: -1,
    editUserInfoOriginal: {},
    employeeUsers: [],
    activeCompDataOriginal: {},
    showPassword: false,
    editUserDialog: false,
    newUserDialog: false,
    editUserDialog: false,
    removeBookings: "",
    editBranchDialog: false,
    newBranchDialog: false,
    selected: [],
    companies: [],
    branches: [],
    activeComp: "",
    showDyflexisApi: false,
    userCompaniesAccess: "",
    salonhubApiFeedback: "",
    salonhubApiSuccess: "",
    salonhubApiCheck: "",
    salonhubApiAlert: false,
    salonhubApiAlertSuccess: false,
    availableApiItems: [
      {
        name: "Drupal",
        id: "drupal"
      },
      {
        name: "Salonhub",
        id: "salonhub"
      },
      {
        name: "Dyflexis",
        id: "dyflexis"
      }
    ],
    editBranchInfo: {
      ECsettings: {},
      receiptData: {
         footer: null
      },
      drupalApiSettings: {
        url: "",
        basicAuth: false,
        basicAuthUsername: "",
        basicAuthPassword: ""
      }
    },
    editBranchInfoOriginal: {
      ECsettings: {},
      receiptData: { footer: null},
      drupalApiSettings: {
        url: "",
        basicAuth: false,
        basicAuthUsername: "",
        basicAuthPassword: ""
      }
    },
    userRoles: [
      {
        name: "Admin",
        id: "admin"
      },
      {
        name: "Manager",
        id: "manager"
      },
      {
        name: "Medewerker",
        id: "employee"
      }
    ],
    headersBranches: [
      {
        text: "Vestigingsnaam",
        align: "left",
        value: "branchName"
      },
      {
        text: "Adres",
        align: "left",
        value: "address"
      },
      {
        text: "Provincie",
        align: "left",
        value: "province"
      },
      {
        text: "",
        align: "right",
        value: "edit"
      }
    ],
    headerUsers: [
      {
        text: "",
        align: "left",
        value: "active"
      },
      {
        text: "Naam",
        align: "left",
        value: "firstName" + "Lastname"
      },
      {
        text: "Rol",
        align: "left",
        value: "userRole"
      },
      {
        text: "Vestigingen",
        align: "left",
        value: "branches"
      },
      {
        text: "Email",
        align: "left",
        value: "email"
      },
      {
        text: "",
        align: "right",
        value: "edit",
        width: "70px"
      },
      {
        text: "",
        value: "data-table-expand",
        align: "right",
        width: "70px",
        sortable: false
      }

    ],
  }),

  created() {
    this.loadUserComp();
  },


  methods: {
    loadUserComp() {
      this.loaded = false;
      let userCompanies = this.userCompanies;
      this.companies = [];
      let counter = 0

      new Promise((resolve, reject)=>{
        if(this.userRole == 'superadmin'){
          db.collection("companies")
          .get()
          .then(snap => {
            this.companies = [];
            snap.forEach(doc => {
              let company = doc.data();
              company.id = doc.id;
              this.companies.push(company);
            });
          })
          .then(()=>{
            resolve();
          })
        }
        else{
          this.userCompanies.forEach(company=>{
          db.collection("companies").doc(company).get()
            .then(doc => {
              let company = doc.data();
              company.id = doc.id;
              this.companies.push(company);
              counter++
              if(counter == this.userCompanies.length){
                resolve()
              }
            })
          })
        }
      })
      .then(()=>{
        // REMEMBER SELECTED COMPANY FROM LOCAL STORAGE
        if(this.userRole == 'superadmin'){
          // Super Admins have access to multiple companies 
          let selectedCompany = window.localStorage.getItem('selectedCompany')

          // Check if a selected company is set in the Local Storage
          if(selectedCompany){
            
            // Check if the selected company is an option
            let selectedCompanyIndex = _.findIndex(this.companies, { 'id': selectedCompany })

            // Selected company is an option, set activeComp
            if(selectedCompanyIndex >= 0){
              this.activeComp = this.companies[selectedCompanyIndex].id;
              this.loadActiveCompData();
            } 
            // Selected company is no option, set first company as activeComp 
            else{
              this.activeComp = this.companies[0].id;
              window.localStorage.setItem('selectedCompany', this.companies[0].id)
              this.loadActiveCompData();
            }
          }
          // No selected company is set 
          else {
            this.activeComp = this.companies[0].id;
            window.localStorage.setItem('selectedCompany', this.companies[0].id)
            this.loadActiveCompData();
          }
        }

        // Regular users have 1 company, just get the first
        else {
          this.activeComp = this.companies[0].id;
          this.loadActiveCompData();
        }
      })
    },

    loadActiveCompData() {
      this.loading = true;
      // Set Active Company as Selected Company in Local Storage
      window.localStorage.setItem('selectedCompany', this.activeComp)
      db.collection("companies")
        .doc(this.activeComp)
        .get()
        .then(doc => {
          if (doc.exists) {
            this.activeCompData = doc.data();
            this.activeCompData.id = doc.id;
            this.activeCompData.dyflexisSettings = this.activeCompData.dyflexisSettings ? this.activeCompData.dyflexisSettings : new Object();
          } else {
            console.log("No such document!");
          }
        })
        .then(() => {
          this.activeCompDataOriginal = _.cloneDeep(this.activeCompData);
          this.selectedLanguage = this.activeCompDataOriginal.languages[0]
        })
        .then(() => {
          this.loading = false;
          this.checkSalonhubConnection();
          this.loadBranches();
          this.loadEmployeeUsers();
        })
        .catch(error => {
          this.loading = false;
          console.error("Error getting document:", error);
        });
    },
    
    editBranch(item) {
      this.editBranchDialog = true;
      this.editedIndex = this.branches.indexOf(item);
      this.editBranchInfo = Object.assign({}, item);
      this.editBranchInfoOriginal = _.cloneDeep(this.editBranchInfo)
      
    },

    deleteBranch() {
      // Prepearing variables for log. This cannot be done inside a forEach
      var logUserFirst = this.userFirstName;
      var logUserLast = this.userLastName;
      var logUserRole = this.userRole;
      var logUserComp = this.activeComp;

      this.selected.forEach(element => {
        db.collection("branches")
          .doc(element.id)
          .delete()
          .then(() => {
            console.log("Branch successfully deleted!");
          })
          .then(() => {
            this.selected = [];
            this.loadBranches();
          })

          .catch(error => {
            console.error("Error removing branch: ", error);
          });
      });
    },

    activeColor(type){
      if(type){
        return 'green'
      }
      else{
        return 'warning';
      }
    },

    loadBranches() {
      this.loading = true;
      db.collection("branches")
        .where("compId", "==", this.activeComp)
        .get()
        .then(snap => {
          this.branches = [];
          snap.forEach(doc => {
            let branchCollection = doc.data();
            branchCollection.id = doc.id;
            this.branches.push(branchCollection);
          });
        })
        .then(() => {
          this.loading = false;
        });
    },

    loadEmployeeUsers() {
      this.loading = true;
      db.collection("users")
        .where("company", "==", this.activeComp)
        .get()
        .then(snap => {
          this.employeeUsers = [];
          snap.forEach(doc => {
            if (this.userRole == "admin" || this.userRole == "superadmin") {
              if (doc.data().userRole != "superadmin") {
                let userCollection = doc.data();
                userCollection.id = doc.id;
                this.employeeUsers.push(userCollection);
              }
            } else {
              if (doc.data().userRole != "superadmin") {
                let userCollection = doc.data();
                userCollection.id = doc.id;
                this.employeeUsers.push(userCollection);
              }
            }
          });
        })
        .then(() => {
          this.loading = false;
        });
    },

    editEmployeeUser(item) {
      this.editUserDialog = true;
      this.editedIndex = this.employeeUsers.indexOf(item);
      this.editUserInfo = _.cloneDeep(item);
      this.editUserInfoOriginal = _.cloneDeep(item);
      bus.$emit("getCompanyBranches", this.editUserInfo.company);
    },

    seeUserLog(){

    },

    createMD5() {
      if (
        this.activeCompData.salonhubApiSettings.customer &&
        this.activeCompData.salonhubApiSettings.username &&
        this.activeCompData.salonhubApiSettings.password
      ) {
        var MD5 = function(string) {
          function roteerlinks(lValue, iShiftBits) {
            return (lValue << iShiftBits) | (lValue >>> (32 - iShiftBits));
          }

          function AddUnsigned(lX, lY) {
            //Onschreven toevoegen
            var lX4, lY4, lX8, lY8, lResult;
            lX8 = lX & 0x80000000;
            lY8 = lY & 0x80000000;
            lX4 = lX & 0x40000000;
            lY4 = lY & 0x40000000;
            lResult = (lX & 0x3fffffff) + (lY & 0x3fffffff);
            if (lX4 & lY4) {
              return lResult ^ 0x80000000 ^ lX8 ^ lY8;
            }

            if (lX4 | lY4) {
              if (lResult & 0x40000000) {
                return lResult ^ 0xc0000000 ^ lX8 ^ lY8;
              } else {
                return lResult ^ 0x40000000 ^ lX8 ^ lY8;
              }
            } else {
              return lResult ^ lX8 ^ lY8;
            }
          }

          function F(x, y, z) {
            return (x & y) | (~x & z);
          }
          function G(x, y, z) {
            return (x & z) | (y & ~z);
          }
          function H(x, y, z) {
            return x ^ y ^ z;
          }
          function I(x, y, z) {
            return y ^ (x | ~z);
          }
          function FF(a, b, c, d, x, s, ac) {
            a = AddUnsigned(a, AddUnsigned(AddUnsigned(F(b, c, d), x), ac));
            return AddUnsigned(roteerlinks(a, s), b);
          }

          function GG(a, b, c, d, x, s, ac) {
            a = AddUnsigned(a, AddUnsigned(AddUnsigned(G(b, c, d), x), ac));
            return AddUnsigned(roteerlinks(a, s), b);
          }

          function HH(a, b, c, d, x, s, ac) {
            a = AddUnsigned(a, AddUnsigned(AddUnsigned(H(b, c, d), x), ac));
            return AddUnsigned(roteerlinks(a, s), b);
          }

          function II(a, b, c, d, x, s, ac) {
            a = AddUnsigned(a, AddUnsigned(AddUnsigned(I(b, c, d), x), ac));
            return AddUnsigned(roteerlinks(a, s), b);
          }

          function ConvertToWordArray(string) {
            var lWordCount;
            var lMessageLength = string.length;
            var lNumberOfWords_temp1 = lMessageLength + 8;
            var lNumberOfWords_temp2 = (lNumberOfWords_temp1 - (lNumberOfWords_temp1 % 64)) / 64;
            var lNumberOfWords = (lNumberOfWords_temp2 + 1) * 16;
            var lWordArray = Array(lNumberOfWords - 1);
            var lBytePosition = 0;
            var lByteCount = 0;
            while (lByteCount < lMessageLength) {
              lWordCount = (lByteCount - (lByteCount % 4)) / 4;
              lBytePosition = (lByteCount % 4) * 8;
              lWordArray[lWordCount] = lWordArray[lWordCount] | (string.charCodeAt(lByteCount) << lBytePosition);
              lByteCount++;
            }

            lWordCount = (lByteCount - (lByteCount % 4)) / 4;
            lBytePosition = (lByteCount % 4) * 8;
            lWordArray[lWordCount] = lWordArray[lWordCount] | (0x80 << lBytePosition);
            lWordArray[lNumberOfWords - 2] = lMessageLength << 3;
            lWordArray[lNumberOfWords - 1] = lMessageLength >>> 29;
            return lWordArray;
          }

          function WordToHex(lValue) {
            var WordToHexValue = "",
              WordToHexValue_temp = "",
              lByte,
              lCount;
            for (lCount = 0; lCount <= 3; lCount++) {
              lByte = (lValue >>> (lCount * 8)) & 255;
              WordToHexValue_temp = "0" + lByte.toString(16);
              WordToHexValue = WordToHexValue + WordToHexValue_temp.substr(WordToHexValue_temp.length - 2, 2);
            }
            return WordToHexValue;
          }

          function Utf8Encode(string) {
            string = string.replace(/\r\n/g, "\n");
            var utftext = "";
            for (var n = 0; n < string.length; n++) {
              var c = string.charCodeAt(n);
              if (c < 128) {
                utftext += String.fromCharCode(c);
              } else if (c > 127 && c < 2048) {
                utftext += String.fromCharCode((c >> 6) | 192);
                utftext += String.fromCharCode((c & 63) | 128);
              } else {
                utftext += String.fromCharCode((c >> 12) | 224);
                utftext += String.fromCharCode(((c >> 6) & 63) | 128);
                utftext += String.fromCharCode((c & 63) | 128);
              }
            }
            return utftext;
          }

          var x = Array();
          var k, AA, BB, CC, DD, a, b, c, d;
          var S11 = 7,
            S12 = 12,
            S13 = 17,
            S14 = 22;
          var S21 = 5,
            S22 = 9,
            S23 = 14,
            S24 = 20;
          var S31 = 4,
            S32 = 11,
            S33 = 16,
            S34 = 23;
          var S41 = 6,
            S42 = 10,
            S43 = 15,
            S44 = 21;
          string = Utf8Encode(string);
          x = ConvertToWordArray(string);
          a = 0x67452301;
          b = 0xefcdab89;
          c = 0x98badcfe;
          d = 0x10325476;

          for (k = 0; k < x.length; k += 16) {
            AA = a;
            BB = b;
            CC = c;
            DD = d;
            a = FF(a, b, c, d, x[k + 0], S11, 0xd76aa478);
            d = FF(d, a, b, c, x[k + 1], S12, 0xe8c7b756);
            c = FF(c, d, a, b, x[k + 2], S13, 0x242070db);
            b = FF(b, c, d, a, x[k + 3], S14, 0xc1bdceee);
            a = FF(a, b, c, d, x[k + 4], S11, 0xf57c0faf);
            d = FF(d, a, b, c, x[k + 5], S12, 0x4787c62a);
            c = FF(c, d, a, b, x[k + 6], S13, 0xa8304613);
            b = FF(b, c, d, a, x[k + 7], S14, 0xfd469501);
            a = FF(a, b, c, d, x[k + 8], S11, 0x698098d8);
            d = FF(d, a, b, c, x[k + 9], S12, 0x8b44f7af);
            c = FF(c, d, a, b, x[k + 10], S13, 0xffff5bb1);
            b = FF(b, c, d, a, x[k + 11], S14, 0x895cd7be);
            a = FF(a, b, c, d, x[k + 12], S11, 0x6b901122);
            d = FF(d, a, b, c, x[k + 13], S12, 0xfd987193);
            c = FF(c, d, a, b, x[k + 14], S13, 0xa679438e);
            b = FF(b, c, d, a, x[k + 15], S14, 0x49b40821);
            a = GG(a, b, c, d, x[k + 1], S21, 0xf61e2562);
            d = GG(d, a, b, c, x[k + 6], S22, 0xc040b340);
            c = GG(c, d, a, b, x[k + 11], S23, 0x265e5a51);
            b = GG(b, c, d, a, x[k + 0], S24, 0xe9b6c7aa);
            a = GG(a, b, c, d, x[k + 5], S21, 0xd62f105d);
            d = GG(d, a, b, c, x[k + 10], S22, 0x2441453);
            c = GG(c, d, a, b, x[k + 15], S23, 0xd8a1e681);
            b = GG(b, c, d, a, x[k + 4], S24, 0xe7d3fbc8);
            a = GG(a, b, c, d, x[k + 9], S21, 0x21e1cde6);
            d = GG(d, a, b, c, x[k + 14], S22, 0xc33707d6);
            c = GG(c, d, a, b, x[k + 3], S23, 0xf4d50d87);
            b = GG(b, c, d, a, x[k + 8], S24, 0x455a14ed);
            a = GG(a, b, c, d, x[k + 13], S21, 0xa9e3e905);
            d = GG(d, a, b, c, x[k + 2], S22, 0xfcefa3f8);
            c = GG(c, d, a, b, x[k + 7], S23, 0x676f02d9);
            b = GG(b, c, d, a, x[k + 12], S24, 0x8d2a4c8a);
            a = HH(a, b, c, d, x[k + 5], S31, 0xfffa3942);
            d = HH(d, a, b, c, x[k + 8], S32, 0x8771f681);
            c = HH(c, d, a, b, x[k + 11], S33, 0x6d9d6122);
            b = HH(b, c, d, a, x[k + 14], S34, 0xfde5380c);
            a = HH(a, b, c, d, x[k + 1], S31, 0xa4beea44);
            d = HH(d, a, b, c, x[k + 4], S32, 0x4bdecfa9);
            c = HH(c, d, a, b, x[k + 7], S33, 0xf6bb4b60);
            b = HH(b, c, d, a, x[k + 10], S34, 0xbebfbc70);
            a = HH(a, b, c, d, x[k + 13], S31, 0x289b7ec6);
            d = HH(d, a, b, c, x[k + 0], S32, 0xeaa127fa);
            c = HH(c, d, a, b, x[k + 3], S33, 0xd4ef3085);
            b = HH(b, c, d, a, x[k + 6], S34, 0x4881d05);
            a = HH(a, b, c, d, x[k + 9], S31, 0xd9d4d039);
            d = HH(d, a, b, c, x[k + 12], S32, 0xe6db99e5);
            c = HH(c, d, a, b, x[k + 15], S33, 0x1fa27cf8);
            b = HH(b, c, d, a, x[k + 2], S34, 0xc4ac5665);
            a = II(a, b, c, d, x[k + 0], S41, 0xf4292244);
            d = II(d, a, b, c, x[k + 7], S42, 0x432aff97);
            c = II(c, d, a, b, x[k + 14], S43, 0xab9423a7);
            b = II(b, c, d, a, x[k + 5], S44, 0xfc93a039);
            a = II(a, b, c, d, x[k + 12], S41, 0x655b59c3);
            d = II(d, a, b, c, x[k + 3], S42, 0x8f0ccc92);
            c = II(c, d, a, b, x[k + 10], S43, 0xffeff47d);
            b = II(b, c, d, a, x[k + 1], S44, 0x85845dd1);
            a = II(a, b, c, d, x[k + 8], S41, 0x6fa87e4f);
            d = II(d, a, b, c, x[k + 15], S42, 0xfe2ce6e0);
            c = II(c, d, a, b, x[k + 6], S43, 0xa3014314);
            b = II(b, c, d, a, x[k + 13], S44, 0x4e0811a1);
            a = II(a, b, c, d, x[k + 4], S41, 0xf7537e82);
            d = II(d, a, b, c, x[k + 11], S42, 0xbd3af235);
            c = II(c, d, a, b, x[k + 2], S43, 0x2ad7d2bb);
            b = II(b, c, d, a, x[k + 9], S44, 0xeb86d391);
            a = AddUnsigned(a, AA);
            b = AddUnsigned(b, BB);
            c = AddUnsigned(c, CC);
            d = AddUnsigned(d, DD);
          }

          var temp = WordToHex(a) + WordToHex(b) + WordToHex(c) + WordToHex(d); //Kopellen
          return temp.toLowerCase(); // Teruggeven
        };
        var MD5HOGANS = MD5(this.activeCompData.salonhubApiSettings.password);
        this.activeCompData.salonhubApiSettings.md5 = MD5HOGANS;
        this.checkSalonHubSettings();
      } else {
        this.salonhubApiFeedback = "Niet alle velden zijn ingevuld.";
        this.salonhubApiAlert = true;
      }
    },

    checkSalonHubSettings() {
      let vm = this;
      let companyname = this.activeCompData.salonhubApiSettings.customer.toLowerCase();
      let username = this.activeCompData.salonhubApiSettings.username.toLowerCase();
      let MD5HOGANS = this.activeCompData.salonhubApiSettings.md5;

      // Checken op, is gebruiker beheerder? En welke salons vallen onder dit wachtwoord? en staat Rapportage aan?
      // Setting users met bevoegdheid : https://public.salonhub.nl/202/hairbeautycomp/joe/47a9c814582f4b77969f1878d1ca82ae/admin/settings/getUsers
      // Setting users met ZONDER bevoegdheid 401 : https://public.salonhub.nl/202/hairbeautycomp/joe/99be01a1c5f43a8dfb05ca5b8bc4d604/admin/settings/getUsers
      var UserResponse = {};
      var BranchResponse = [];
      axios
        .get(
          "https://public.salonhub.nl/current/" +
            companyname +
            "/" +
            username +
            "/" +
            MD5HOGANS +
            "/admin/settings/getUsers"
        ) // Haalt user rechten binnen
        .then(response => {
          // console.log(response);
          UserResponse = response.data;
          UserResponse = _.find(UserResponse, { user: username }); //username als variable gebruikersnaam
          // Rechten 64 = Beheerder // Rechten 96 = Beheerder met filiaal monitor
          if (UserResponse.rights == "64" || UserResponse.rights == "96") {
            // console.log("Beheerder rechten zijn aanwezig!");
            this.salonhubApiSuccess = "API succesvol gekoppeld.";
            this.salonhubApiAlertSuccess = true;
            this.salonhubApiCheck = "success";

            axios
              .get(
                "https://public.salonhub.nl/current/" +
                  companyname +
                  "/" +
                  username +
                  "/" +
                  MD5HOGANS +
                  "/admin/settings/retrieveSettings"
              ) // Haalt user rechten binnen
              .then(response => {
                //Iteratie over salons id en name
                _.map(response.data.salons, function(value, index) {
                  // return value.id;
                  BranchResponse.push({ salonhubid: value.id, name: value.name });
                });
                //BrancheResponse bestaat uit ID en naam salon.
                this.activeCompData.salonhubApiSettings.salons = BranchResponse;
              })
              .then(() => {
                this.updateCompanyApi();
              })
              .catch(error => {});
          } else {
            console.log("Geen beheerder");
            this.salonhubApiFeedback = "De ingevoerder gebruiker is geen beheerder";
            this.salonhubApiAlert = true;
            this.salonhubApiCheck = "warning";
          }
        })

        .catch(error => {
          if (401 === error.response.status) {
            // console.error("401, Geen toegang");
            this.salonhubApiFeedback = "De gegevens zijn niet correct ingevuld.";
            this.salonhubApiAlert = true;
            this.salonhubApiCheck = "warning";
          } else {
            // console.error("Overige Error");
            this.salonhubApiFeedback = "Verbinden maken is niet gelukt. Probeer het later nog eens.";
            this.salonhubApiAlert = true;
            this.salonhubApiCheck = "warning";
          }
        });
    },

    checkSalonhubConnection() {
      if (this.activeCompData.apiItems.salonhub == true) {
        if (
          this.activeCompData.salonhubApiSettings.customer &&
          this.activeCompData.salonhubApiSettings.username &&
          this.activeCompData.salonhubApiSettings.md5
        ) {

          let vm = this;
          let companyname = this.activeCompData.salonhubApiSettings.customer;
          let username = this.activeCompData.salonhubApiSettings.username;
          let MD5HOGANS = this.activeCompData.salonhubApiSettings.md5;

          var UserResponse = {};
          var BranchResponse = [];
          axios
            .get(
              "https://public.salonhub.nl/current/" +
                companyname +
                "/" +
                username +
                "/" +
                MD5HOGANS +
                "/admin/settings/getUsers"
            )
            .then(response => {
              // console.log(response);
              UserResponse = response.data;
              UserResponse = _.find(UserResponse, { user: username });
              
              if (UserResponse.rights == "64" || UserResponse.rights == "96") {
                this.salonhubApiCheck = "success";
              } else {
                this.salonhubApiCheck = "warning";
                this.salonhubApiFeedback = "De ingevoerder gebruiker is geen beheerder";
                this.salonhubApiAlert = true;
              }
            })
            .catch(error => {
              // console.error("Verbinding maken niet gelukt: ", error)
              if (401 === error.response.status) {
                this.salonhubApiCheck = "warning";
                this.salonhubApiFeedback = "De gegevens zijn niet correct ingevuld.";
                this.salonhubApiAlert = true;
              } else {
                this.salonhubApiCheck = "warning";
                this.salonhubApiFeedback = "Verbinden maken is niet gelukt. Probeer het later nog eens.";
                this.salonhubApiAlert = true;
              }
            });
        } else {
          this.salonhubApiCheck = "";
        }
      } else {
        this.salonhubApiCheck = "";
      }
    },

    updateCompanySocial() {
      db.collection("companies")
        .doc(this.activeComp)
        .update({
          social: this.activeCompData.social
        })
        .then(() => {
          db.collection("log").add({
            time: new Date(),
            user: this.userFirstName + " " + this.userLastName,
            userType: this.userRole,
            company: this.userCompany,
            actionType: "User Action",
            software: String(platform.os),
            browser: platform.name + ' ' + platform.version, 
            pillarrrVersion: this.$store.state.version,
            action: "Social settings aangepast: " + this.activeCompData.name,
            extra:
              "<b>Facebook:</b> " +
              this.activeCompData.social.facebook +
              "<br>" +
              "<b>Facebook Link:</b> " +
              this.activeCompData.social.facebookUrl +
              "<br>" +
              "<b>Instagram:</b> " +
              this.activeCompData.social.instagram +
              "<br>" +
              "<b>Instagram Link:</b> " +
              this.activeCompData.social.instagramUrl +
              "<br>" +
              "<b>Twitter:</b> " +
              this.activeCompData.social.twitter +
              "<br>" +
              "<b>Twitter Link:</b> " +
              this.activeCompData.social.twitterUrl +
              "<br>" +
              "<b>Pinterest:</b> " +
              this.activeCompData.social.pinterest +
              "<br>" +
              "<b>Pinterest Link:</b> " +
              this.activeCompData.social.pinterestUrl +
              "<br>" +
              "<b>Google +:</b> " +
              this.activeCompData.social.googleplus +
              "<br>" +
              "<b>Google + Link:</b> " +
              this.activeCompData.social.googleplusUrl
          });
        })
        .then(() => {
          console.log("Social settings succesfully updated");
          this.loadActiveCompData();
        })
        .catch(error => {
          console.error("Error updating document: ", error);
        });
    },

    updateCompanyApi() {
      let salonhubActive = this.activeCompData.apiItems.salonhub;
      let salonhubCustomer = "";
      let salonhubUsername = "";
      let salonhubPassword = "";
      let salonhubMd5 = "";
      let salonhubSalons = "";

      if (salonhubActive == true) {
        salonhubCustomer = this.activeCompData.salonhubApiSettings.customer;
        salonhubUsername = this.activeCompData.salonhubApiSettings.username;
        salonhubPassword = this.activeCompData.salonhubApiSettings.password;
        salonhubMd5 = this.activeCompData.salonhubApiSettings.md5;
        salonhubSalons = this.activeCompData.salonhubApiSettings.salons;
      }

      db.collection("companies")
        .doc(this.activeComp)
        .update({
          apiActive: this.activeCompData.apiActive,
          apiItems: this.activeCompData.apiItems,
          dyflexisSettings: this.activeCompData.dyflexisSettings,
          salonhubApiSettings: {
            customer: salonhubCustomer,
            username: salonhubUsername,
            password: salonhubPassword,
            md5: salonhubMd5,
            salons: salonhubSalons
          }
        })
        .then(() => {
          db.collection("log").add({
            time: new Date(),
            user: this.userFirstName + " " + this.userLastName,
            userType: this.userRole,
            company: this.userCompany,
            actionType: "User Action",
            software: String(platform.os),
            browser: platform.name + ' ' + platform.version, 
            pillarrrVersion: this.$store.state.version,
            action: "API settings aangepast: " + this.activeCompData.name,
            extra:
              "<b>Active API:</b> " +
              this.activeCompData.apiActive +
              "<br>" +
              "<b>API items:</b> " +
              JSON.stringify(this.activeCompData.apiItems) +
              "<br><br>" +
              "<b>SALONHUB API SETTINGS:</b> " +
              "<br>" +
              "<b>Customer: </b> " +
              salonhubCustomer +
              "<br>" +
              "<b>Username: </b> " +
              salonhubUsername +
              "<br>" +
              "<b>Salons: </b> " +
              salonhubSalons
          });
        })
        .then(() => {
          console.log("API settings succesfully updated");
          this.loadActiveCompData();
        })
        .catch(error => {
          console.error("Error updating document: ", error);
        });
    },
  },

  computed: {  
    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
    demoMode(){
      return this.$store.state.demoMode;
    },
    theme(){
      return (this.$vuetify.theme.dark) ? 'dark' : 'light'
    },
    companyNarrowcasting() {
      if (_.includes(this.$store.state.companyPackages, "narrowcasting")) {
        return true;
      } else {
        return false;
      }
    },
    companyJourney() {
      if (_.includes(this.$store.state.companyPackages, "customerjourney")) {
        return true;
      } else {
        return false;
      }
    },
    apiSettingsChanged(){
      if (_.isEqual(this.activeCompData.apiActive, this.activeCompDataOriginal.apiActive) == false || _.isEqual(this.activeCompData.apiItems, this.activeCompDataOriginal.apiItems) == false) {
        return true
      } else {
        return false
      }
    },
    socialChanged() {
      if (_.isEqual(this.activeCompData.social, this.activeCompDataOriginal.social) == false) {
        return true;
      } else {
        return false;
      }
    },
    filteredCompanies(){
      if(this.searchCompanies && this.searchCompanies.length > 0){
        return this.companies.filter(company => {
          return company.name.toLowerCase().includes(this.searchCompanies.toLowerCase());
        });
      } else {
        return this.companies
      }
    }
    
  }
};
</script>

<style>

.send-survey-button-preview {
  font-family: "Sofia Pro", sans-serif;
  position: fixed;
  right: 300px;
  bottom: 50px;
  padding: 12px 55px 14px 15px;
  height: 45px;
  text-align: left;
  color: #ffffff;
  font-weight: 600;
  background: url("../assets/icons/next-button-white.svg") no-repeat center right 4px;
}

.send-survey-button-preview .v-btn__content {
  font-weight: 600;
}

.send-survey-button-preview:hover,
.send-survey-button-preview:active,
.send-survey-button-preview:focus {
  position: fixed;
  right: 300px;
  bottom: 50px;
}

.custom-table ul {
  padding: 5px 0;
  list-style: square;
}

.custom-table li{
  display: list-item;
}
@import "~vue-wysiwyg/dist/vueWysiwyg.css";
p.settings-tab-introtext {
  padding: 10px 0 0 0;
  font-size: 16px;
}

.email-preview {
  padding: 20px 0;
  background-color: #f6f7fb;
}

.email-wrapper {
  width: 560px;
  margin: 20px auto;
  padding: 20px;
  background: #ffffff;
  border: 1px solid #e8e9ee;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.04);
  border-radius: 5px;
}

.user-permissions-table {
  padding: 3px 0;
}

.user-permissions-table p {
  padding: 3px 0 0 0;
  margin: 0 0 5px 0!important;
  font-weight: 600;
  font-size: 12px;
}

.user-permissions-table ul {
  padding: 0;
}

.user-permissions-table ul li {
  font-size: 12px;
  margin: 0;
  display: list-item;
}

.tab-inner-wrapper.padding {
  padding: 20px;
  position: relative;
}

.tab-header.table {
  padding: 20px 20px 0 20px;
}

.first-item-button {
  padding: 100px 0;
}


</style>